import { NavigationTranslationType, ProfileTranslationType, ErrorsTranslationType, CommonTranslationType } from "../../features/types";

// Remove nested structure type and export a flatter object structure
export const common = {
  navigation: {
    dashboard: "控制面板",
    profile: "个人资料",
    signOut: "退出登录"
  },
  profile: {
    title: "个人资料",
    dangerZone: "危险区域",
    deleteAccount: "删除账户",
    confirmDelete: "确认删除",
    deleteWarning: "您确定要删除您的账户吗？此操作无法撤销。",
    confirmDeleteButton: "删除账户",
    accountDeleted: "账户已删除",
    accountDeletedMessage: "您的账户已成功删除。"
  },
  cancel: "取消",
  delete: "删除",
  deleteConfirmation: "确认删除",
  deleteConfirmationMessage: "您确定要删除",
  confirm: "确认",
  errors: {
    error: "错误",
    notFound: "页面未找到",
    deleteAccountError: "删除账户时出现错误。请重试。",
    loadStoryError: "加载故事失败。请重试。",
    loadCharactersError: "加载角色失败。请重试。",
    summaryError: "生成摘要时出错。请重试。"
  }
};
